import React, { useEffect, createElement } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import AnnouncementBar from './components/AnnouncementBar';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import ImpactMetrics from './components/ImpactMetrics';
import WhyItWorks from './components/WhyItWorks';
import Features from './components/Features';
import Interfaces from './components/Interfaces';
import Integrations from './components/Integrations';
import PoweredByFluidWeb from './components/PoweredByFluidWeb';
import AdvancedCapabilities from './components/AdvancedCapabilities';
import Pricing from './components/Pricing';
import FAQ from './components/FAQ';
import CTA from './components/CTA';
import Footer from './components/Footer';
import TermsOfUse from './pages/TermsOfUse';
import PrivacyPolicy from './pages/PrivacyPolicy';
import FluidFormPreview from './pages/FluidFormPreview';
import TryFluidForm from './pages/TryFluidForm';
import ChatBubble from './components/ChatBubble';
export function App() {
  useEffect(() => {
    document.title = 'FluidForm — AI-Native Forms That Feel Human';
    // Preconnect to external domains for faster resource loading
    const preconnectDomains = ['https://uploadthingy.s3.us-west-1.amazonaws.com', 'https://cdn.magicpatterns.com', 'https://app.fluid-form.ai', 'https://accounts.fluid-form.ai', 'https://www.googletagmanager.com'];
    preconnectDomains.forEach(domain => {
      const link = document.createElement('link');
      link.rel = 'preconnect';
      link.href = domain;
      link.crossOrigin = 'anonymous';
      document.head.appendChild(link);
    });
    // Google Analytics (gtag.js)
    if (!document.querySelector('script[src*="googletagmanager.com/gtag/js"]')) {
      const gtagScript = document.createElement('script');
      gtagScript.async = true;
      gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-9F433GY2HD';
      document.head.appendChild(gtagScript);
      const gtagInit = document.createElement('script');
      gtagInit.textContent = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'G-9F433GY2HD');
      `;
      document.head.appendChild(gtagInit);
    }
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', 'Build intelligent forms in minutes. Let users respond with text, voice, documents, and photos — get clean, validated, schema-aligned data every time. Free to start.');
    let metaOgTitle = document.querySelector('meta[property="og:title"]');
    if (!metaOgTitle) {
      metaOgTitle = document.createElement('meta');
      metaOgTitle.setAttribute('property', 'og:title');
      document.head.appendChild(metaOgTitle);
    }
    metaOgTitle.setAttribute('content', 'FluidForm — AI-Native Forms That Feel Human');
    let metaOgDescription = document.querySelector('meta[property="og:description"]');
    if (!metaOgDescription) {
      metaOgDescription = document.createElement('meta');
      metaOgDescription.setAttribute('property', 'og:description');
      document.head.appendChild(metaOgDescription);
    }
    metaOgDescription.setAttribute('content', 'Build intelligent forms in minutes. Let users respond with text, voice, documents, and photos — get clean, validated, schema-aligned data every time.');
    let metaOgType = document.querySelector('meta[property="og:type"]');
    if (!metaOgType) {
      metaOgType = document.createElement('meta');
      metaOgType.setAttribute('property', 'og:type');
      document.head.appendChild(metaOgType);
    }
    metaOgType.setAttribute('content', 'website');
    let metaTwitterCard = document.querySelector('meta[name="twitter:card"]');
    if (!metaTwitterCard) {
      metaTwitterCard = document.createElement('meta');
      metaTwitterCard.setAttribute('name', 'twitter:card');
      document.head.appendChild(metaTwitterCard);
    }
    metaTwitterCard.setAttribute('content', 'summary_large_image');
    let metaTwitterTitle = document.querySelector('meta[name="twitter:title"]');
    if (!metaTwitterTitle) {
      metaTwitterTitle = document.createElement('meta');
      metaTwitterTitle.setAttribute('name', 'twitter:title');
      document.head.appendChild(metaTwitterTitle);
    }
    metaTwitterTitle.setAttribute('content', 'FluidForm — AI-Native Forms That Feel Human');
    let metaTwitterDescription = document.querySelector('meta[name="twitter:description"]');
    if (!metaTwitterDescription) {
      metaTwitterDescription = document.createElement('meta');
      metaTwitterDescription.setAttribute('name', 'twitter:description');
      document.head.appendChild(metaTwitterDescription);
    }
    metaTwitterDescription.setAttribute('content', 'Build intelligent forms in minutes. Text, voice, documents, photos — validated and schema-aligned. Free to start.');
  }, []);
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/terms" element={<TermsOfUse data-id="element-3" />} data-id="element-2" />
        <Route path="/privacy" element={<PrivacyPolicy data-id="element-5" />} data-id="element-4" />
        <Route path="/preview" element={<FluidFormPreview data-id="element-7" />} data-id="element-6" />
        <Route path="/try" element={<TryFluidForm data-id="element-9" />} data-id="element-8" />
        <Route path="/" element={<div className="w-full min-h-screen font-sans" data-id="element-11">
              <div className="sticky top-0 z-50" data-id="element-12">
                <AnnouncementBar data-id="element-13" />
                <Navbar data-id="element-14" />
              </div>
              <Hero data-id="element-15" />
              <ImpactMetrics data-id="element-16" />
              <WhyItWorks data-id="element-17" />
              <Features data-id="element-18" />
              <Interfaces data-id="element-19" />
              <Integrations data-id="element-20" />
              <PoweredByFluidWeb data-id="element-21" />
              <AdvancedCapabilities data-id="element-22" />
              <Pricing data-id="element-23" />
              <FAQ data-id="element-24" />
              <CTA data-id="element-25" />
              <Footer data-id="element-26" />
            </div>} data-id="element-10" />
      </Routes>
      <ChatBubble data-id="element-27" />
    </BrowserRouter>;
}